<h3 mat-dialog-title>Account Warning</h3>

<mat-dialog-content>
  Your EZLynx account is past due. To avoid interruption of service please call the billing department immediately at
  972-355-9749 (option 3) or email us at <a href="mailto:billing@ezlynx.com">billing&#64;ezlynx.com</a>.
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button"
          color="primary"
          mat-button
          mat-dialog-close>Continue</button>
</mat-dialog-actions>